import { useState } from 'react';

import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui';

import { AddFactForm } from './add-fact-form';

/** The button that adds a fact, which opens the form where the fact is typed. */
export const AddFact = ({ personId }: { personId: string }) => {
  const [isAdding, setIsAdding] = useState(false);

  return isAdding ? (
    <AddFactForm personId={personId} onDone={() => setIsAdding(false)} />
  ) : (
    <Button
      variant="ghost"
      size="xs"
      className="-ml-2 text-foreground-muted"
      onClick={() => setIsAdding(true)}
    >
      <Icons.plus className="size-3" />
      Add fact
    </Button>
  );
};
